export default {
    GET_CONFIG: '[CONFIG] GET_CONFIG',
    GET_CONFIG_RESULT: '[CONFIG] GET_CONFIG_RESULT',
    GET_CONFIG_ERROR: '[CONFIG] GET_CONFIG_ERROR',

    TYPE_GET_CONFIG: 'get_config',

    /**
     * custom prefix order
     */
    CONFIG_XML_PATH_USE_CUSTOM_PREFIX: 'webpos/checkout/use_custom_prefix',
    CONFIG_XML_PATH_CUSTOM_PREFIX: 'webpos/checkout/custom_prefix',
    CONFIG_XML_PATH_GENERAL_LOCALE_CODE: 'general/locale/code',
    CONFIG_XML_PATH_MAGENTO_VERSION: 'magento_version'
}



// WEBPACK FOOTER //
// ./src/view/constant/ConfigConstant.js